// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9230388e","455":"746e5f82","977":"e17ef01f"}[chunkId] + ".chunk.js";
};